import { Box } from 'roo-ui/components';
import { DepositPayDisclaimer, PointsDisclaimer, FeesDisclaimer, VoucherDisclaimer, RefundDisclaimer } from './Disclaimers';

const GlobalDisclaimers = () => (
  <Box mb={12}>
    <PointsDisclaimer.Body />
    <FeesDisclaimer.Body />
    <VoucherDisclaimer.Body />
    <RefundDisclaimer.Body />
    <DepositPayDisclaimer.Body />
  </Box>
);

export default GlobalDisclaimers;
